<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="900"
      persistent
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-toolbar max-height="64">
          <v-toolbar-title>
            {{ $t("banks") }}
          </v-toolbar-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon small color="info" class="mt-1">
                  mdi-information-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("warningAboutBanks") }}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <Banks
          v-if="limitBanks"
          :selectedBanks="selectedBanks"
          :isDisabled="disabledSubmit"
          @submit="submit"
          @onBanksChange="onBanksChange"
          :dialog="dialog"
          @closeDialog="closeDialog"
        />
      </v-card>
    </v-dialog>

    <v-form ref="form" v-model="valid">
      <v-card class="mb-2 pb-2" v-for="(card, index) in cards" :key="index">
        <v-toolbar dense elevation="0">
          <v-toolbar-title class="subtitle-1">{{
            card.titleCard
          }}</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
        <v-row
          class="pa-4"
          v-for="(row, indexRow) in card.rows"
          :key="indexRow"
        >
          <!-- <v-col cols="12 pb-0">
            <div class="d-flex overline justify-start align-center">
              <div class="grey--text">{{ row.titleRow }}</div>
              <v-divider class="ml-4"></v-divider>
            </div>
          </v-col> -->

          <v-col
            cols="12"
            md="4"
            lg="3"
            v-for="(col, indexCol) in row.cols"
            :key="indexCol"
          >
            <div v-if="!col.hide">
              <div v-if="col.field.name != 'verificar_banco'">
                <div class="pb-2 subtitle-2">
                  {{ col.label }}
                  <v-tooltip top v-if="col.tips">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small icon v-bind="attrs" v-on="on">
                        <v-icon small color="info">
                          mdi-information-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span v-html="infoKey(col.field.name)"></span>
                  </v-tooltip>
                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small icon v-bind="attrs" v-on="on" disabled />
                    </template>
                  </v-tooltip>
                </div>

                <!-- TYPE TEXT -->
                <v-text-field
                  v-if="col.field.type == 'text'"
                  :disabled="
                    hasOnlyPayForFun && col.field.name == 'maximo_saque'
                  "
                  type="text"
                  v-model="col.field.model"
                  @keypress="isNumber($event)"
                  :name="col.field.name"
                  :append-icon="col.field.appendIcon"
                  :prepend-icon="col.field.icon"
                  :rules="
                    col.field.name == 'default_fee' ? defaultFeeRules : []
                  "
                  solo-inverted
                  required
                  dense
                  hide-details="auto"
                  class="subtitle-2 caption"
                ></v-text-field>

                <!-- TYPE SELECT -->
                <v-select
                  v-if="col.field.type == 'select'"
                  v-model="col.field.model"
                  :items="col.field.items"
                  item-text="text"
                  item-value="value"
                  :label="$t('toSelect')"
                  solo-inverted
                  dense
                  hide-details
                  class="subtitle-2"
                ></v-select>

                <v-btn
                  v-if="col.label == $t('variableCommissions.label')"
                  style="width: 100%"
                  class="info"
                  @click="openVariableCommissionsDialog"
                >
                  <v-icon small left>
                    mdi-cog
                  </v-icon>
                  {{ $t("settings") }}
                </v-btn>
              </div>

              <div v-else>
                <div class="col-md-12 pa-0">
                  <div class="pb-2 subtitle-2">
                    {{ col.label }}
                    <v-tooltip top v-if="col.tips">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small icon v-bind="attrs" v-on="on">
                          <v-icon small color="info">
                            mdi-information-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span v-html="infoKey(col.field.name)"></span>
                    </v-tooltip>
                  </div>
                  <v-select
                    v-model="col.field.model"
                    :items="col.field.items"
                    item-text="text"
                    item-value="value"
                    :label="$t('toSelect')"
                    solo-inverted
                    dense
                    hide-details
                    class="subtitle-2"
                    @change="handleFieldChange(col.field)"
                    :disabled="hasOnlyPayForFun"
                  ></v-select>
                  <v-btn
                    v-if="limitBanks"
                    style="width: 100%"
                    @click="chooseBanks"
                    color="info"
                    class="mt-4"
                  >
                    {{ $t("chooseBanks") }}
                  </v-btn>
                </div>
                <!-- <div class="align-self-center"> -->
                <!-- <div class="pb-2 subtitle-2" v-if="!$vuetify.breakpoint.xsOnly">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small icon v-bind="attrs" v-on="on" disabled />
                    </template>
                  </v-tooltip>
                </div> -->
                <!-- <v-btn
                  v-if="limitBanks"
                  small
                  @click="chooseBanks"
                  color="info"
                  :class="$vuetify.breakpoint.xsOnly ? 'mt-2' : ''"
                >
                  {{ $t("chooseBanks") }}
                </v-btn> -->
                <!-- </div> -->
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="d-flex justify-end">
        <div class="pa-4">
          <v-btn
            small
            class="ml-2 white black--text"
            :disabled="disabledCancel"
            @click="getConfigOnline"
          >
            {{ $t("toCancel") }}
          </v-btn>
          <v-btn
            small
            class="ml-2 info"
            :disabled="disabledSubmit || !valid"
            @click="submit"
          >
            {{ $t("toSave") }}
          </v-btn>
        </div>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import Banks from "./banks.vue";
import hasTwoFactorAuth from "@/util/hasTwoFactorAuth";

export default {
  name: "",
  components: {
    Banks,
  },
  data: () => ({
    valid: false,
    cards: [],
    selectedBanks: [],
    limitBanks: null,
    dialog: false,
    banksIds: [],
    disabledSubmit: false,
    disabledCancel: false,
  }),

  computed: {
    operatorHasTwoFactorAuth() {
      return hasTwoFactorAuth.includes(localStorage.getItem("operator"));
    },
    paymentMethods() {
      return this.$store.state.operator.payment_methods ?? [];
    },
    hasOnlyPayForFun() {
      let hasPaybrokers = false;
      let hasPayForFun = false;

      this.paymentMethods.forEach((method) => {
        if (
          method.nome_gateway == "Paybrokers" &&
          method.method_status == "1"
        ) {
          hasPaybrokers = true;
        } else if (
          method.nome_gateway == "Pay4Fun" &&
          method.method_status == "1"
        ) {
          hasPayForFun = true;
        }
      });

      return !hasPaybrokers && hasPayForFun;
    },
    card() {
      return [
        {
          titleCard: this.$t("transactionsSettings"),
          rows: [
            {
              titleRow: this.$t("controlOfLimits"),
              cols: [
                {
                  label: this.$t("minimumDepositAmount"),
                  tips: "",
                  field: {
                    name: "minimo_deposito",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("depositFee"),
                  tips: true,
                  field: {
                    name: "taxa_deposito",
                    model: "",
                    type: "text",
                    icon: "",
                    appendIcon: "mdi-percent-outline",
                  },
                },
                {
                  label: this.$t("maximumWithdrawalValue"),
                  tips: true,
                  field: {
                    name: "maximo_saque",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("minimumWithdrawalAmount"),
                  tips: "",
                  field: {
                    name: "minimo_saque",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("withdrawalRate"),
                  tips: true,
                  field: {
                    name: "taxa_saque",
                    model: "",
                    type: "text",
                    icon: "",
                    appendIcon: "mdi-percent-outline",
                  },
                },
                {
                  label: this.$t("maximumInstantWithdrawalValue"),
                  tips: true,
                  field: {
                    name: "saque_instantaneo",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                {
                  label: this.$t("vinculoDeposit"),
                  tips: true,
                  field: {
                    icon: "",
                    name: "vinculo_deposito",
                    model: "vinculo_deposito",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "1",
                      },
                      {
                        text: this.$t("no"),
                        value: "0",
                      },
                    ],
                  },
                },
                {
                  label: this.$t("emailVerification.name"),
                  tips: true,
                  field: {
                    icon: "",
                    name: "email_validation",
                    model: "email_validation",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "1",
                      },
                      {
                        text: this.$t("no"),
                        value: "0",
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("allowedBanksConfiguration"),
          rows: [
            {
              cols: [
                // Porcentagem de encerramento
                {
                  label: this.$t("bankVerification"),
                  tips: true,
                  field: {
                    icon: "",
                    appendIcon: "mdi-percent-outline",
                    name: "verificar_banco",
                    model: "verificar_banco",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "1",
                      },
                      {
                        text: this.$t("no"),
                        value: "0",
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("generalSettings"),
          rows: [
            {
              titleRow: this.$t("controlOfLimits"),
              cols: [
                {
                  label: this.$t("allowPixKeyEdit"),
                  tips: true,
                  field: {
                    name: "block_pix",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "0",
                      },
                      {
                        text: this.$t("no"),
                        value: "1",
                      },
                    ],
                    icon: "",
                  },
                },
                // Encerrar aposta
                {
                  label: this.$t("cashOut"),
                  field: {
                    name: "cashout",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "1",
                      },
                      {
                        text: this.$t("no"),
                        value: "0",
                      },
                    ],
                  },
                },
                // Porcentagem de encerramento
                {
                  label: this.$t("percentageCashOut"),
                  field: {
                    name: "porcentagem_encerrar_aposta",
                    model: "",
                    type: "text",
                    icon: "",
                  },
                },
                // Verificação de duas etapas
                {
                  label: this.$t("multifactor.field"),
                  hide: this.operatorHasTwoFactorAuth === false,
                  tips: true,
                  field: {
                    name: "multifactor",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: this.$t("yes"),
                        value: "1",
                      },
                      {
                        text: this.$t("no"),
                        value: "0",
                      },
                    ],
                  },
                },
                // Página principal
                {
                  label: this.$t("homePage.field"),
                  tips: true,
                  field: {
                    name: "home_page",
                    model: "",
                    type: "select",
                    items: [
                      {
                        text: this.$t("sports"),
                        value: "sportbook",
                      },
                      {
                        text: this.$t("casino"),
                        value: "casino",
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          titleCard: this.$t("defaultFeeSettingsAndVariableCommissions"),
          rows: [
            {
              titleRow: this.$t("defaultFee"),
              cols: [
                {
                  label: this.$t("defaultFee"),
                  tips: true,
                  field: {
                    name: "default_fee",
                    model: "",
                    type: "text",
                    icon: "",
                    appendIcon: "mdi-percent-outline",
                  },
                },
                {
                  label: this.$t("variableCommissions.label"),
                  tips: false,
                  field: {
                    //
                  },
                },
              ],
            },
          ],
        },
      ];
    },
    defaultFeeRules() {
      return [
        (v) => /^([0-9]|[1-9][0-9]|99)$/.test(v) || this.$t("defaultFeeError"),
      ];
    },
  },

  created() {
    this.cards = this.card;
  },
  mounted() {
    this.getConfigOnline();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    async getConfigOnline() {
      this.disabledCancel = true;
      const request = await this.$request.get(
        "/administrator/operator/getConfigOnline"
      );
      for (let card of this.cards) {
        for (let row of card.rows) {
          for (let col of row.cols) {
            col.field.model = request.dados[col.field.name];
            if (
              col.field.name == "taxa_deposito" ||
              col.field.name == "taxa_saque"
            ) {
              col.field.model = Number(col.field.model).toFixed(2);
            }

            if (col.field.name === "vinculo_deposito") {
              this.initialDepositBond = col.field.model;
            }

            if (col.field.name === "verificar_banco") {
              this.limitBanks = col.field.model == "1";
              if (this.limitBanks) {
                this.banksIds = request.dados.bancos.map(
                  (bank) => bank.cod_bank
                );

                this.selectedBanks = request.dados.bancos.map((bank) => ({
                  ...bank,
                  text: `${bank.cod_bank} - ${bank.nome_curto}`,
                }));
              }
            }
          }
        }
      }

      this.disabledCancel = false;
    },

    // Verifica se é numero
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // Submit
    async submit() {
      this.disabledSubmit = true;

      const body = {};
      const data = this.cards
        .map((item) => item.rows)
        .reduce((a, b) => [...a, ...b])
        .map((item) => item.cols)
        .reduce((a, b) => [...a, ...b]);

      for (let item of data) {
        // default_fee must be a integer 0-99
        if (item.field.name == "default_fee") {
          item.field.model = parseInt(item.field.model).toString();
        }

        if (!item.hide) {
          body[item.field.name] = item.field.model;
        }
      }

      if (this.limitBanks) {
        if (this.banksIds.length > 0) {
          const bancos = {};
          let i = 0;

          for (const id of this.banksIds) {
            bancos[`bancos[${i}]`] = id;
            i++;
          }

          Object.assign(body, bancos);
        } else if (this.banksIds.length == 0) {
          this.$store.commit("setFeedbackSnack", {
            msg: this.$t("selectAtLeastOneBank"),
            color: "warning",
          });

          this.disabledSubmit = false;
          return;
        }
      } else {
        delete body.bancos;
      }

      const postDataBank = await this.$request.post(
        "/administrator/operator/editConfigOnline",
        body
      );
      if (postDataBank.length == 0) {
        this.disabledSubmit = false;
        return;
      }

      if (this.initialDepositBond) {
        if (Number(this.initialDepositBond) !== Number(body.vinculo_deposito)) {
          this.$store.commit(
            "updateOperatorDepositBondConfiguration",
            body.vinculo_deposito
          );
        }
      }

      if (!this.limitBanks) {
        this.banksIds = [];
        this.selectedBanks = [];
      }

      this.$store.commit("setFeedbackSnack", {
        msg: postDataBank.messages,
        color: "success",
      });

      this.disabledSubmit = false;
    },
    infoKey: function(key) {
      const info = {
        minimo_deposito: this.$t("minimunDepoistAmount"),
        multi_min_bonus: this.$t("minimumMultiplierToGoalBonus"),
        taxa_deposito: this.$t("percentageOnDeposit"),
        maximo_saque: this.$t("maximumValueOfWithdrawal"),
        minimo_saque: this.$t("minimumValueOfWithdrawal"),
        taxa_saque: this.$t("percentageOnWithdrawals"),
        percentual_bonus: this.$t("percentageOfBonus"),
        valor_max_bonus: this.$t("limitMaximumAmountBonus"),
        multi_min_betbonus: this.$t("minimulMultiplerForBettingBonus"),
        saque_instantaneo: this.$t("maximumValueUserWithdrawInstantly"),
        block_pix: this.$t("allowPixKeyEdit"),
        verificar_banco: this.$t("chooseBanksHint"),
        vinculo_deposito: this.$t("vinculoDepositTooltip"),
        email_validation: this.$t("emailVerification.forWithdraws"),
        default_fee: this.$t("defaultFeeTooltip"),
        multifactor: this.$t("multifactor.tooltip"),
        home_page: this.$t("homePage.tooltip"),
      };

      if (this.hasOnlyPayForFun) {
        info.verificar_banco = this.$t("cantVerifyBank");
      }

      return info[key] || null;
    },
    handleFieldChange(field) {
      this.limitBanks = field.model == "1";
    },
    onBanksChange(banksIds) {
      this.banksIds = banksIds;
    },
    chooseBanks() {
      this.dialog = true;
    },
    openVariableCommissionsDialog() {
      this.$root.$emit("openVariableCommissions");
    },
  },
};
</script>

<style scoped>
.pre-formatted {
  white-space: pre;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.absolute {
  position: absolute;
  margin: 0.25rem 0;
  padding: 0;
}

.v-tooltip__content {
  font-size: 14px !important;
  max-width: 256px !important;
  opacity: 1 !important;
  padding: 16px 16px;
}
</style>
